<template>
    <div>
        <p class="text">{{ $t('faq.tivimate.step8.selectLite') }}</p>
        <p class="text">{{ $t('faq.tivimate.step8.regulatVersion') }}</p>
        <a class="text link" :href="epgLink">{{ epgLink }}</a>
        <p class="text">{{ $t('faq.tivimate.step8.liteVersion') }}</p>
        <div>
            <a class="text link" :href="epgLiteLinkGz" target="_blank">{{ epgLiteLinkGz }}</a><span class="text">{{ $t('faq.tivimate.step8.zip') }}</span>
        </div>
        <div class="text-margin">
            <a class="text link" :href="epgLiteLink" target="_blank">{{ epgLiteLink }}</a><span class="text">{{ $t('faq.tivimate.step8.xml') }}</span>
        </div>
        <p class="text">{{ $t('faq.tivimate.step8.yourTvGuide') }}</p>
        <p class="text">{{ $t('faq.tivimate.step8.inTheEvent') }}</p>
        <p class="text">{{ $t('faq.tivimate.step8.chooseYourFavorites') }}</p>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters(['brandConfig']),
        tvLinkWithoutHttps() {
            return this.brandConfig.tvLink.replace('https://', '');
        },
        epgLink() {
            return `https://epg.${this.tvLinkWithoutHttps}/utc.xml.gz`
        },
        epgLiteLinkGz() {
            return `https://epg.${this.tvLinkWithoutHttps}/utc.lite.xml.gz`
        },
        epgLiteLink() {
            return `https://epg.${this.tvLinkWithoutHttps}/utc.lite.xml`
        },
    }
}
</script>
<style scoped>
@import "../../../components/styles/guides-default-styles.css";
</style>
